// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-dashboard-pending-certificate-modal--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  position: relative; }\n  .student-dashboard-pending-certificate-modal--layout .student-dashboard-pending-certificate-modal--close-icon {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    color: var(--secondary);\n    cursor: pointer;\n    font-size: 1.8rem; }\n", ""]);
// Exports
module.exports = exports;
